import * as React from "react";
import cn from "clsx";
import { Card } from "../card";
import { Heading } from "../typography/heading";
import { Icon } from "../icon";
import { IconProps } from "../icon";

export type CardActionProps = {
  role?: "hero" | "sidekick";
  variant?: "primary" | "secondary" | "tertiary";
  title: string;
  url?: string;
  onClick?: () => void;
  lead?: string;
  icon?: { prefix: IconProps["prefix"]; name: string };
} & React.HTMLAttributes<HTMLDivElement>;

const CardAction = React.forwardRef<HTMLDivElement, CardActionProps>(
  (
    {
      className,
      variant = "secondary",
      title,
      url,
      onClick,
      style,
      lead,
      icon,
      role = "hero",
      ...props
    },
    ref
  ) => {
    const Tag = url ? "a" : "button";
    return (
      <Tag href={url ? url : null} onClick={onClick} className={cn("in-card-action__link", className)}>
        <Card
          variant={variant}
          className={cn(
            "in-card-action",
            `in-card-action--${variant}`,
            `in-card--${role}`
          )}
        >
          <div ref={ref} {...props} className={cn("in-card-action__content")}>
            <div className={cn("in-card-action__inner")}>
              {icon && (
                <Icon
                  prefix={icon?.prefix}
                  iconName={icon?.name}
                  size={role == "hero" ? "l" : "m"}
                  className="in-card-action__icon"
                />
              )}
              <div
                className={cn("in-card-action__heading",
                  role === "hero"
                    ? "in-card-action__heading-hero"
                    : "in-card-action__heading-sidekick"
                )}
              >
                {title}
              </div>
              {lead && <div className="in-card-action__lead">{lead}</div>}
            </div>

            <div className={cn("in-card-action__action-icon-container")}>
              <div />
              <Icon
                className="in-card-action__action-icon"
                prefix="fasr"
                iconName="arrow-right"
                size={role == "hero" ? "s" : "xs"}
              />
            </div>
          </div>
        </Card>
      </Tag>
    );
  }
);

CardAction.displayName = "CardAction";

export { CardAction };
